module.exports = __webpack_public_path__ + "media/MATT.fb835275.mp4";